var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12868",
    "data-name": "Group 12868",
    transform: "translate(-558 -2475)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(558 2475)",
    fill: "#f4ea5b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pin_2_",
    "data-name": "pin (2)",
    transform: "translate(510.821 2486.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M79.179,0A15.2,15.2,0,0,0,64,15.179c0,11.2,14,24.507,14.6,25.069a.844.844,0,0,0,1.156,0c.6-.562,14.6-13.871,14.6-25.069A15.2,15.2,0,0,0,79.179,0Zm0,23.611a8.433,8.433,0,1,1,8.433-8.433A8.443,8.443,0,0,1,79.179,23.611Z",
    transform: "translate(-64)",
    fill: "#143727"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.1621346ecb8de66b5870f841c38bea82.svg";
export { ForwardRef as ReactComponent };